import { Base } from "../../framework/base";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "./recordFurtherEducationGroupNode";

export interface IRecordFurtherEducationGroupNodes {
    items: IRecordFurtherEducationGroupNode[];
}

export class RecordFurtherEducationGroupNodes implements IRecordFurtherEducationGroupNodes {
    items: RecordFurtherEducationGroupNode[];

    constructor();
    constructor(obj: IRecordFurtherEducationGroupNodes);
    constructor(obj?: any) {
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordFurtherEducationGroupNode);
    }
}